import React from 'react';
import ClickOutside from 'react-onclickout';
import { Tooltip } from 'components/shared';
import { Picker } from 'emoji-mart';
import { IconEmoji, IconEmojiOn } from 'icons';
import hasClass from 'helpers/hasClass';
import 'emoji-mart/css/emoji-mart.css';

interface Props {
  onSelect: (emoji: any) => void;
}

interface State {
  isOpen: boolean;
}

export default class EmojiPicker extends React.Component<Props, State> {
  state = { isOpen: false };

  clickOut = (e: any) => {
    if (this.state.isOpen && !hasClass(e.target, 'tippy-box')) {
      this.setState({ isOpen: false });
    }
  };

  onSelect = (emoji: any) => {
    this.setState({ isOpen: false });
    this.props.onSelect(emoji);
  };

  toggleOpen = () => this.setState((state) => ({ isOpen: !state.isOpen }));

  render() {
    return (
      <ClickOutside onClickOut={this.clickOut}>
        <Tooltip
          interactive
          placement="bottom"
          visible={this.state.isOpen}
          content={
            <div className="emoji-picker__wrapper">
              <Picker
                native
                onSelect={this.onSelect}
                custom={[]}
                darkMode={false}
              />
            </div>
          }
        >
          <button
            className="emoji-picker__toggle group"
            tabIndex={-1}
            onClick={this.toggleOpen}
          >
            {this.state.isOpen ? (
              <IconEmojiOn className="block text-dark" />
            ) : (
              <>
                <IconEmoji className="block group-hover:hidden" />
                <IconEmojiOn className="hidden group-hover:block" />
              </>
            )}
          </button>
        </Tooltip>
      </ClickOutside>
    );
  }
}
